/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class VideoEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mb_id: 0,
            hash: '',
            media: null,
            cover_ms: 0,
            firstLoad: false,
            thumbVisible: false,
            clientWidth: 300,
            clientHeight: 100
        };

        this.setCoverImage = this.setCoverImage.bind(this);
        this.saveVideoEdits = this.saveVideoEdits.bind(this);

        this.videoRef = React.createRef();
        this.canvasRef = React.createRef();

    }

    static getDerivedStateFromProps(props, state) {

        if (!state.firstLoad) {
            let nextState = {
                firstLoad: true
            };
            if (props.accessoryServiceId && props.accessoryHash) {
                if (props.postData.services[props.accessoryServiceId].mb_id) {
                    nextState.mb_id = props.postData.services[props.accessoryServiceId].mb_id;
                }
                if (props.accessoryHash) {
                    if (props.postData.services[props.accessoryServiceId].cover_ms !== undefined &&
                        props.postData.services[props.accessoryServiceId].cover_ms[props.accessoryHash] !== undefined) {
                        nextState.cover_ms = props.postData.services[props.accessoryServiceId].cover_ms[props.accessoryHash];
                    }
                }
            } else {
                if (nextState.mb_id) {
                    nextState.mb_id = props.postData.shared.mb_id;
                }
                if (props.accessoryHash) {
                    if (props.postData.shared.cover_ms !== undefined &&
                        props.postData.shared.cover_ms[props.accessoryHash] !== undefined) {
                        nextState.cover_ms = props.postData.shared.cover_ms[props.accessoryHash];
                    }
                }
            }

            if (props.accessoryHash) {
                nextState.hash = props.accessoryHash;
                let thumb = props.mediaThumbs.find(({hash}) => { return nextState.hash === hash; });
                nextState.media = thumb;
            }

            return nextState;

        }

        return null;
    }

    setCoverImage() {
        if (this.videoRef.current) {
            let currentTime = this.videoRef.current.currentTime,
                clientHeight = this.videoRef.current.clientHeight,
                clientWidth = this.videoRef.current.clientWidth;

            if (this.canvasRef.current) {
                let context = this.canvasRef.current.getContext("2d");
                this.canvasRef.current.setAttribute('width', clientWidth);
                this.canvasRef.current.setAttribute('height', clientHeight);
                context.drawImage(this.videoRef.current, 0, 0, clientWidth, clientHeight);
            }

            let cover_ms = Math.floor(currentTime * 1000);
            this.setState({
                cover_ms,
                thumbVisible: true,
                clientHeight,
                clientWidth
            });

        }
    }

    saveVideoEdits(e) {
        e.preventDefault();

        this.props.confirmAction({
            accessoryServiceId: this.props.accessoryServiceId,
            cover_ms: this.state.cover_ms,
            hash: this.state.hash
        });

    }

    render() {

        let videoSrc = null,
            thumbInstructions = null,
            canvasStyles = {'display': 'block'};

        if (this.state.media && this.state.media.original) {
            videoSrc = this.state.media.original;
        }

        if (!this.state.thumbVisible) {
            let instructionStyles = {
                width: this.state.clientWidth,
                height: this.state.clientHeight
            };

            canvasStyles.display = 'none';

            thumbInstructions = (
                <div className="thumb-instructions" style={instructionStyles}>
                    Use the timeline on the video to choose a cover and hit "Set Cover Image"
                </div>
            );

        }

        // hack to get the first frame to show up if
        // the user hasn't already selected one
        if (!this.state.cover_ms) {
            videoSrc += "#t=0.1";
        }

        return (
            <div className="pt-video-editor">
                <div className="video-editor-display">
                    <div className="video-wrapper">
                        <div className="video-player">
                            <video ref={this.videoRef}
                                controls
                                controlsList="nodownload nofullscreen noremoteplayback"
                                disablePictureInPicture
                                onLoadedData={(e) => {
                                    if (e.currentTarget.readyState === 4) {
                                        if (!this.state.thumbVisible) {
                                            if (this.state.cover_ms > 0) {
                                                let currentTime = this.state.cover_ms / 1000;
                                                this.videoRef.current.currentTime = currentTime;
                                            } else {
                                                this.videoRef.current.currentTime = 1;
                                            }
                                        } else {
                                            this.setState({
                                                clientHeight: this.videoRef.current.clientHeight,
                                                clientWidth: this.videoRef.current.clientWidth
                                            });
                                        }
                                    }
                                }}
                                onSeeked={(e) => {
                                    this.setCoverImage();
                                }}
                                onPause={(e) => {
                                    this.setCoverImage();
                                }}>
                                <source src={videoSrc}/>
                            </video>
                        </div>
                        <div className="thumb-display">
                            <canvas ref={this.canvasRef} style={canvasStyles}></canvas>
                            <div className="cover-label">Video Cover</div>
                        </div>
                    </div>
                </div>
                <div className="pt-accessory-actions">
                    <div role="button" className="action-cancel" onClick={this.props.cancelAction}>
                        Go Back
                    </div>
                    <button type="button" className="btn-delete action-delete" onClick={this.saveVideoEdits}>
                        Save
                    </button>
                </div>
            </div>
        );
    }
}

VideoEditor.displayName = "VideoEditor";

export default VideoEditor;
